import React from 'react'
import Layout from '../layout/layout'
import UploadSection from '../upload_section'
import HomeBox from '../home_box'

export default function Home() {

    return (
        <Layout>
            <div>
                <UploadSection />
                  <HomeBox />
            </div>
        </Layout>
    )
}